export default "__VITE_ASSET__858f607a__"